import ValidService from "../../../service/ValidService";
let model = {};

model.dataForm = {
    id: undefined, // optional 
    trang_thai: undefined, // required, min: 0, max: 2 0: Từ chối, 1: đã duyệt, 2: đang chờ xử lý
    hien_thi: undefined, // required hien thi
    thong_tin: // required Thông tin sản vật
    {
        ten: undefined, // required Tên sản vật
        ten_en: undefined, // optional Tên tiếng anh
        dia_chi: undefined, // optional Địa chỉ sản vật
        thanh_pho: undefined, // optional Thành phố
        dien_thoai: undefined, // required Điện thoại liên hệ sản vật
        email: undefined, // optional Email liên hệ sản vật
        website: undefined, // optional Website giới thiệu sản vật
        gioi_thieu: undefined, // optional Giới thiệu tóm tắt về sản vật
        doi_tuong: undefined, // optional Đối tượng khách hàng hướng tới
    },
    chu_doanh_nghiep: undefined, // optional thông tin chủ doanh nghiệp
    chi_tiet: // optional Thông tin chi tiết khách sạn - nhà hàng, show ở màn chi tiết khách sạn - nhà hàng
    {
        mo_ta: undefined, // optional Mô tả điểm đến
        dich_vu: undefined, // optional Mổ tả dịch vụ
    },
    mediaId: undefined, // optional id media
    creationTime: undefined, // optional 
    lastModificationTime: undefined, // optional Thời gian lần sửa bản ghi cuối cùng
    lastModifierUserId: undefined, // optional Mã người sửa cuối
}

model.validForm = {}

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {}
};

export default model;